export default "__VITE_ASSET__49e255d3__"